import React from "react";
import cx from "classnames";
import styles from "./ModalFooter.module.scss";
import type { ModalFooterProps } from "./ModalFooter.types";
import useBuildVariantProps from "../../../../modules/theme/useBuildVariantProps";

/**
 * Modal Footer component for displaying footer actions in a modal.
 */
const ModalFooter: React.FC<ModalFooterProps> = ({
  type = "1Button",
  style = "NoStroke",
  primaryButton,
  secondaryButton,
  className,
  ...restProps
}) => {

  let primaryButtonComponent, secondaryButtonComponent;

  if (primaryButton) {
    primaryButtonComponent = <>{primaryButton}</>;
  }

  if (type === '2Buttons' && secondaryButton) {
    secondaryButtonComponent = <>{secondaryButton}</>;
  }
  const variantProps = useBuildVariantProps(
    'modal-footer',
    { type, style }
  );

  return (
    <div 
      className={cx(styles.modalFooter, { 
          [styles.oneButton]: type === "1Button"
        }, 
        className
      )} 
      {...variantProps} 
      {...restProps}
    >
      {secondaryButtonComponent}
      {primaryButtonComponent}
    </div>
  );
};

export default ModalFooter;
